
export class GeolocationErrorHandler {
  // GeolocationPositionError Cannot be found by the CICD. I <3 JS.
  // Forced to use "any"
  getMessage(e: any, isMobile: boolean): string {
    const device = isMobile ? 'phone' : 'device'
    switch (e.code) {
      case e.PERMISSION_DENIED:
        return `Your ${device} does not allow Peregre Works to find your location.`
      case e.POSITION_UNAVAILABLE:
        return 'Your location was not found. Please check your browser permissions.'
      case e.TIMEOUT:
        return 'Finding your location is taking too long. Please try again later.'
      default:
        return 'Unknown error'
    }
  }
}
